import Vue from 'vue'
import Router from 'vue-router'
import { isEmpty } from 'lodash-es'
import store from '@/store'

Vue.use(Router)

const routers = [
  {
    path: '/channel/:channel',
    name: 'channel',
    component: () => import('./pages/channel'),
    meta: {
      title: ''
    }
  },
  {
    path: '/iframe',
    name: 'iframe',
    component: () => import('./pages/iframe'),
    meta: {
      title: ''
    }
  },
  {
    path: '/qyllb/:channel',
    name: 'channel',
    component: () => import('./pages/qyllb'),
    meta: {
      title: ''
    }
  },
  {
    //宽带业务
    path: '/broadband/:channel',
    name: 'Broadband',
    component: () => import('./pages/broadband'),
    meta: {
      title: ''
    },
    children: [
      {
        path: '',
        name: 'Broadband',
        component: () => import('./pages/broadband-box'),
        meta: { title: '首页', icon: 'table' }
      },
      {
        //宽带业务
        path: '/broadbanddetails/:channel',
        name: 'Broadbanddetails',
        component: () => import('./views/broadband/Template1/broadbanddetails.vue'),
       
      },
      {
        //宽带业务
        path: '/broadbandSubmit/:channel',
        name: 'BroadbandSubmit',
        component: () => import('./views/broadband/Template1/broadbandSubmit.vue'),
       
      }
    ]
  }
]

const router = new Router({
  routes: routers,
  mode: 'history',
  base: process.env.VUE_APP_ROUTER_SUB_PATH
})

router.beforeEach(async (to, from, next) => {
  const { params } = to
  if (isEmpty(store.state.globalChannelInfo)) {
    await store.dispatch('serverInit', params)
  }
  next()
})
export default router
